'use client';

import styled, { keyframes, css } from 'styled-components';

const pulse = keyframes`
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.55; transform: scale(0.85); }
`;

export interface DotIndicatorProps {
  color: string;
  size?: number;
  glow?: boolean;
  pulse?: boolean;
}

export const DotIndicator = styled.span.attrs({ 'aria-hidden': 'true' })<DotIndicatorProps>`
  display: inline-block;
  width: ${(p) => p.size ?? 6}px;
  height: ${(p) => p.size ?? 6}px;
  border-radius: 50%;
  background: ${(p) => p.color};
  flex-shrink: 0;
  ${(p) =>
    p.glow &&
    css`
      box-shadow: 0 0 6px ${p.color};
    `}
  ${(p) =>
    p.pulse &&
    css`
      animation: ${pulse} 1.6s ease-in-out infinite;
    `}
`;
